<template>
  <!-- Blog-section start -->
  <section class="blog-seven-section">
    <div class="container">
      <div class="section-heading-two section-heading-seven text-center">
        <div class="row">
          <div class="col-md-12 aos aos-init aos-animate" data-aos="fade-up">
            <img
              src="@/assets/img/heading-logo-small.png"
              class="img-fluid"
              alt="title-img"
            />
            <h2>From Our Blog</h2>
            <p>Checkout what people are saying about our commuity businesses</p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6 d-flex">
            <div class="blog-seven grid-blog-seven aos" data-aos="fade-up">
              <div class="blog-image-seven">
                <router-link to="blog-details"
                  ><img
                    class="img-fluid"
                    src="@/assets/img/blog/blog-seven1.jpg"
                    alt="Post Image"
                /></router-link>
                <div class="blog-date">
                  <h4>09 <br /><span>Jun</span></h4>
                </div>
              </div>
              <div></div>
              <div class="blog-content-seven">
                <p class="blog-category-seven">
                  <a href="javascript:void(0);"><span>Breakfast</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >Competitive Analysis for Enterprerneurs in 2023
                  </router-link>
                </h3>
                <p class="blog-description-seven">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-seven">
                  <li>
                    <div class="post-author-seven">
                      <div class="post-author-img-seven">
                        <img
                          src="@/assets/img/profiles/avatar-05.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> Amara </span></a
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 d-flex">
            <div class="blog-seven grid-blog-seven aos" data-aos="fade-up">
              <div class="blog-image-seven">
                <router-link to="blog-details"
                  ><img
                    class="img-fluid"
                    src="@/assets/img/blog/blog-seven2.jpg"
                    alt="Post Image"
                /></router-link>
                <div class="blog-date">
                  <h4>
                    11 <br />
                    <span>Aug</span>
                  </h4>
                </div>
              </div>
              <div></div>
              <div class="blog-content-seven">
                <p class="blog-category-seven">
                  <a href="javascript:void(0);"><span>Lunch</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >Three Powerful Tricks For Online Advertising
                  </router-link>
                </h3>
                <p class="blog-description-seven">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-seven">
                  <li>
                    <div class="post-author-seven">
                      <div class="post-author-img-seven">
                        <img
                          src="@/assets/img/profiles/avatar-07.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> John </span></a
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 d-flex">
            <div class="blog-seven grid-blog-seven aos" data-aos="fade-up">
              <div class="blog-image-seven">
                <router-link to="blog-details"
                  ><img
                    class="img-fluid"
                    src="@/assets/img/blog/blog-seven3.jpg"
                    alt="Post Image"
                /></router-link>
                <div class="blog-date">
                  <h4>
                    14 <br />
                    <span>Mar</span>
                  </h4>
                </div>
              </div>
              <div></div>
              <div class="blog-content-seven">
                <p class="blog-category-seven">
                  <a href="javascript:void(0);"><span>Dinner</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >The Best Spa Saloons for your relaxations?
                  </router-link>
                </h3>
                <p class="blog-description-seven">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-seven">
                  <li>
                    <div class="post-author-seven">
                      <div class="post-author-img-seven">
                        <img
                          src="@/assets/img/profiles/avatar-04.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> Alex </span></a
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Blog-section end -->
</template>
